module.exports = __webpack_public_path__ + "img/flavor5.ca3cd977.png";